var $a22580c229649927$exports = {};
$a22580c229649927$exports = {
    "valid": `\u{6709}\u{6548}`
};


export {$a22580c229649927$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
